import type { RouteRecordRaw } from 'vue-router';

export function createRoutes(root: string): RouteRecordRaw[] {
    return [
        {
            path: root,
            name: 'verification-configurations',
            component: () => import('./pages/Layout.vue'),
            meta: {
                layout: 'app',
                auth: true,
            },
            children: [
                {
                    path: '',
                    name: 'verification-configurations.index',
                    component: () => import('./pages/Index.vue'),
                },
                {
                    path: ':id',
                    name: 'verification-configurations.show',
                    component: () => import('./pages/Node.vue'),
                },
            ],
        },
    ];
}
